var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetMyTeams } from '@/shared/hooks/task/useGetMyTeams';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import MultiSelect, { splitItems } from '../multiselect/MultiSelect';
export var MyTeamsMultiSelect = function (_a) {
    var selectedItems = _a.selectedItems, placeholder = _a.placeholder, onChange = _a.onChange;
    var formatMessage = useIntl().formatMessage;
    var data = useGetMyTeams().data;
    var relationLabels = useMemo(function () {
        return data === null || data === void 0 ? void 0 : data.map(function (x) { return ({
            id: x.id,
            label: x.name,
            code: x.code.toString(),
            sort: x.name.toLowerCase(),
        }); }).sort(dynamicSort('sort'));
    }, [data]);
    var allLabels = useMemo(function () {
        return relationLabels && __spreadArray([
            { id: '0', label: formatMessage({ id: 'WithoutTeams' }), code: '0' }
        ], relationLabels, true);
    }, [formatMessage, relationLabels]);
    var _b = splitItems(allLabels, selectedItems, 'code'), selectedLabels = _b[0], availableLabels = _b[1];
    return (_jsx(MultiSelect, { selectedItem: selectedLabels, onItemRemoved: function (item) { return onChange(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(function (label) { return label !== item.value.code; })); }, onItemSelected: function (item) { return onChange(__spreadArray(__spreadArray([], (selectedItems !== null && selectedItems !== void 0 ? selectedItems : []), true), [item.code], false)); }, items: availableLabels, placeholder: placeholder }));
};
export var FilterMyTeamsMultiSelect = function (_a) {
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(MyTeamsMultiSelect, { onChange: function (value) {
                var _a;
                var _b;
                setFilter((_a = {},
                    _a[item] = ((_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0) > 0 ? value : undefined,
                    _a));
            }, selectedItems: activeFilters[item], placeholder: label })),
    });
};
